<div class="markdown-html text-center">
	<div>{{'workflow.test.completed' | translate}}</div>
	<ng-container *ngIf="(workflowItemKey.property$ | async) as results">
		<div *ngIf="results.rechts.fehlwert || results.links.fehlwert">{{'workflow.missing_value_epilog' | translate}}</div>
		<div class="centered">
			<!-- Tested == null statt === null weil es auch auf undefined true ergibt und somit ähnlich isNil ist -->
			<span *ngIf="
				results.links.Hz512_volume != null &&
				results.links.Hz1024_volume != null &&
				results.links.Hz2048_volume != null &&
				results.links.Hz4096_volume != null &&
				results.rechts.Hz512_volume != null &&
				results.rechts.Hz1024_volume != null &&
				results.rechts.Hz2048_volume != null &&
				results.rechts.Hz4096_volume; else elseBlock"
			>
				{{ 'workflow.test.digitalHearingLoss.averageByInput' | translate }}
			</span>
			<ng-template #elseBlock>
				<span>
				{{ 'workflow.test.digitalHearingLoss.averageByCompute' | translate }}
				</span>
			</ng-template>
			<table>
				<tbody>
				<tr *ngIf="!results.rechts.fehlwert">
					<td class="left-align">{{ 'word.rightEar' | translate }} 512 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{results.rechts.Hz512 | number:'1.1-1'}} dB</td>
				</tr>
				<tr *ngIf="!results.rechts.fehlwert">
					<td class="left-align">{{ 'word.rightEar' | translate }} 1024 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{results.rechts.Hz1024 | number:'1.1-1'}} dB</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'word.rightEar' | translate }} 2048 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td *ngIf="!results.rechts.fehlwert" class="right-align cell-padding">{{results.rechts.Hz2048 | number:'1.1-1'}} dB</td>
					<td *ngIf="results.rechts.fehlwert" class="right-align cell-padding">{{results.zusammenfassung.rechts.transformed.Hz2048_missingValue | number:'1.1-1'}} %
						(<workflow-missing-value-icon class="missing-icon"></workflow-missing-value-icon>)</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'word.rightEar' | translate }} 4096 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td *ngIf="!results.rechts.fehlwert" class="right-align cell-padding">{{results.rechts.Hz4096 | number:'1.1-1'}} dB</td>
					<td *ngIf="results.rechts.fehlwert" class="right-align cell-padding">{{results.zusammenfassung.rechts.transformed.Hz4096_missingValue | number:'1.1-1'}} %
						(<workflow-missing-value-icon class="missing-icon"></workflow-missing-value-icon>)</td>
				</tr>
				<tr></tr>
				<tr *ngIf="!results.links.fehlwert">
					<td class="left-align">{{ 'word.leftEar' | translate }} 512 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{results.links.Hz512 | number:'1.1-1'}} dB</td>
				</tr>
				<tr *ngIf="!results.links.fehlwert">
					<td class="left-align">{{ 'word.leftEar' | translate }} 1024 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{results.links.Hz1024 | number:'1.1-1'}} dB</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'word.leftEar' | translate }} 2048 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td *ngIf="!results.links.fehlwert" class="right-align cell-padding">{{results.links.Hz2048 | number:'1.1-1'}} dB</td>
					<td *ngIf="results.links.fehlwert" class="right-align cell-padding">{{results.zusammenfassung.links.transformed.Hz2048_missingValue | number:'1.1-1'}} %
						(<workflow-missing-value-icon class="missing-icon"></workflow-missing-value-icon>)</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'word.leftEar' | translate }} 4096 Hz</td>
					<td class="center-align cell-padding">:</td>
					<td *ngIf="!results.links.fehlwert" class="right-align cell-padding">{{results.links.Hz4096 | number:'1.1-1'}} dB</td>
					<td *ngIf="results.links.fehlwert" class="right-align cell-padding">{{results.zusammenfassung.links.transformed.Hz4096_missingValue | number:'1.1-1'}} %
						(<workflow-missing-value-icon class="missing-icon"></workflow-missing-value-icon>)</td>
				</tr>
				</tbody>
			</table>
		</div>
	</ng-container>
</div>
